// import config from 'config';
import { authHeader } from '../_helpers';
import Userauth from '../auth/js';
import axios from 'axios'

export const userService = {
    login,
    refresh,
    logout,
    getAll
};

function login(email, password, remember) {

    return  axios.post('/admin/login',{ email: email, password: password, remember: remember })
        .then( response =>{

            const user = response.data

            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                // localStorage.setItem('user', JSON.stringify(user));

                Userauth.localLogin(response.data, remember)
                
                // set token in all request
                axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`
            }

            return user;

        })
}

function refresh(refresh_token) {
    
    return axios.post('/admin/refresh', { refresh_token: refresh_token })
    .then( response =>{

        const user = response.data

        if (user.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            //    localStorage.setItem('user', JSON.stringify(user));

            Userauth.refreshToken(user)
                
            // set token in all request
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`
        }

        return user;

    })
}

function logout() {

    const { refresh_token } = JSON.parse(localStorage.getItem('user'))

    return  axios.post('/admin/logout', { refresh_token: refresh_token } )
        .then( response =>{
            
            // remove user from local storage to log user out
            // localStorage.removeItem('user');
            Userauth.logout()

            return response;

        }).catch(error =>{ 
            // remove user from local storage to log user out
            // localStorage.removeItem('user');
            Userauth.logout()

            return error;
        })
    
}

function getAll() {

    //
    return axios.get('/admin/profile', { headers: authHeader() })
    .then( response =>{
        //
        Userauth.updateUser(response.data)
        
        return response.data
    })
}
